import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { Typography } from "@mui/material";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

export default function RangeSlider({ label, min, max, range, valueChange }) {
    const handleChange = (event, newValue) => {
        valueChange(newValue);
    };
    const { getFontSize } = useResponsiveStyles();

    return (
        <Box sx={{ p: 1, m: 1 }}>
            <Typography sx={getFontSize("body1")} gutterBottom>
                {label}
            </Typography>
            <Slider
                value={range}
                onChange={handleChange}
                min={min}
                max={max}
                valueLabelDisplay="auto"
                valueLabelFormat={(value) => ` ₹${value}`}
                sx={getFontSize("body1")}
                color="error"
                disableSwap
            />
        </Box>
    );
}
